export const mappings = ['app', 'affaire-form', 'affaire', 'operations'];
